import { ThemeOptions } from "@mui/material";
import { typographyVariants } from "../constants";

export const muiButton: ThemeOptions["components"] = {
  MuiButton: {
    defaultProps: {
      style: { borderRadius: 28 },
    },
    styleOverrides: {
      root: ({ theme }) => {
        return {
          ...typographyVariants.bodyMedium,
          minHeight: "48px",
          textTransform: "none",
          cursor: "pointer",
          "&:disabled": {
            ...theme.palette.buttons.primary.disabled,
          },
        };
      },
    },
    variants: [
      {
        props: { variant: "primary" },
        style: ({ theme }) => ({
          ...theme.palette.buttons.primary.default,
          "&:hover": {
            ...theme.palette.buttons.primary.hover,
          },
          "&:disabled": {
            ...theme.palette.buttons.primary.disabled,
          },
        }),
      },
      {
        props: { variant: "secondary" },
        style: ({ theme }) => ({
          ...theme.palette.buttons.secondary.default,
          "&:hover": {
            ...theme.palette.buttons.secondary.hover,
          },
          "&:disabled": {
            ...theme.palette.buttons.secondary.disabled,
          },
        }),
      },
      {
        props: { variant: "text" },
        style: ({ theme }) => ({
          ...theme.palette.buttons.text.default,
        }),
      },
    ],
  },
};
